import { joinValues } from '@/utils/urls'

export const server = process.env.NEXT_PUBLIC_API_ENDPOINT || '/rest'

export const getAccountRelatedUrl = (workspaceId: string): string =>
  joinValues(server, 'workspaces', workspaceId)

const urls = {
  auth: {
    login: '/login',
    logout: '/logout',
  },
}

export type ProjectIgnoredFile = ProjectRelatedPath & {
  ignoredFile: string
}

type AccountRelatedPathKeys = 'workspaceId'

export type AccountRelatedPath = {
  [key in AccountRelatedPathKeys]?: string
} & { urlFor?: string }

export type ProjectRelatedPath = AccountRelatedPath & {
  projectId: string
}

export type BranchRelatedPath = ProjectRelatedPath & {
  branchName: string
}

export type UserRelatedPath = AccountRelatedPath & {
  userId: string
}

export type ListBranchesQueryParams = {
  t?: 'all' | 'tracked' | 'untracked'
} & PaginationQueryParams

export type ListProjectsParams = AccountRelatedPath & {
  params?:
    | {
        exclude_score?: boolean
        filter?: string
      }
    | PaginationQueryParams
}

export type ListPullRequestsParams = ProjectRelatedPath & {
  params: ListPullRequestsQueryParams
}

export type ListPullRequestsQueryParams = {
  b?: string
  l?: 'inbound' | 'outbound'
  s?: 'open' | 'closed'
} & PaginationQueryParams

export type PaginationQueryParams = {
  page: number
  size: number
  filter?: string
  connectionId?: string
  sort?: string[]
  exclude_project?: any
  roles?: any
  search?: any
  severities?: any
  enabled?: any
  legacy_code?: boolean
  sources?: any
}

export type ReportQueryParams = {
  branch?: string
  end?: string
  start: string
}

export type ExportScanParams = {
  severities?: string
  search?: string
  developer?: string
  detected?: boolean
  dismissed?: boolean
  format?: 'csv' | 'sarif' | 'threadfix' | undefined
}

export enum HttpMethods {
  'DELETE' = 'DELETE',
  'GET' = 'GET',
  'PATCH' = 'PATCH',
  'POST' = 'POST',
  'PUT' = 'PUT',
}

export default urls
